<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				<img v-if="!collapsed" src="/static/img/logo.png" alt="">
				<img v-if="collapsed" src="/static/img/xiao_logo.png" alt="">
			</el-col>
			<el-col :span="4">
				<div class="tools" @click.prevent="collapsed=!collapsed">
					<i v-if="!collapsed" class="el-icon-s-fold"></i>
					<i v-if="collapsed" class="el-icon-s-unfold"></i>
				</div>
			</el-col>
			<el-col :span="10" class="userinfo">
				<el-button class="userinfo-inner" type="text">用户名：{{user_name}}</el-button>
				<el-button class="userinfo-inner" type="text" @click="modify_password_is=true">【修改密码】</el-button>
				<el-button class="userinfo-inner" @click="logout" type="text">【退出登录】</el-button>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'">
				<GeminiScrollbar class="my-scroll-bar">
					<el-menu :default-active="path" ref="elMenu" :unique-opened="true" :collapse="collapsed">
						<el-submenu :index="item.path" v-for="(item,indexa) in routes" :key="indexa">
							<template slot="title">
								<i :class="item.icon_url" class="iconfont"></i>
								<span>{{item.name}}</span>
							</template>
							<el-menu-item :index="items.path" @click="hreftwo(items)" v-for="(items,indexs) in item.children" v-if="xianshi(items.path)" :key="indexs">
								<template slot="title">
									<i :class="items.icon_url" class="iconfont"></i>
									<span> {{items.name}}</span>
								</template>
							</el-menu-item>
						</el-submenu>
					</el-menu>
				</GeminiScrollbar>
			</aside>
			<section class="content-container">
				<div class="biaoqian" v-if="path!='index'">
					<GeminiScrollbar class="my-scroll-bar">
						<el-tag v-for="(tag,index) in tags" :key="tag.name" closable :type="path!=tag.path?'info':''" @click="hreftwo(tag,0)" @close="tag_del(tag,index)"> {{tag.name}} </el-tag>
					</GeminiScrollbar>
				</div>
				<transition name="fade" mode="out-in">
					<router-view></router-view>
				</transition>
			</section>
		</el-col>
		<el-dialog title="修改密码" width="500px" :visible="modify_password_is" @close="modify_password_is = false" :close-on-click-modal="false">
			<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" >
			<el-row class="tree-content" :gutter="20">
			  <el-col :span="24" >
				<el-form-item prop="old_password">
				  <el-input v-model="ruleForm2.old_password" show-password class="w100" placeholder="请输入旧密码"></el-input>
			  </el-form-item>
			  </el-col>
			  <el-col :span="24">
				<el-form-item prop="password">
				  <el-input v-model="ruleForm2.password" show-password class="w100" placeholder="请输入新密码"></el-input>
			  </el-form-item>
			  </el-col>
			  <el-col :span="24">
				<el-form-item prop="re_password">
				  <el-input v-model="ruleForm2.re_password" show-password class="w100" placeholder="请确认新密码"></el-input>
			  </el-form-item>
			  </el-col>
			</el-row>
		  </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="modify_password_is = false">取消</el-button>
				<el-button size="mini" type="primary" @click.native="yungongaddNew('')">提交</el-button>
			</div>
		</el-dialog>
	</el-row>
</template>
<script>
import {strengthIndicator} from "@/../store/password-strength";
export default {
	name:'home',
	data() {
		const validatorCaptcha = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入新密码'));
			}else if(value.length<8){
				return callback(new Error('新密码长度不可小于8位'));
			} else if(strengthIndicator(value).lever>=3) {
				callback();
			}else{
				return callback(new Error('密码强度不够'));
			}
		};
		const validator_re_password = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请确认新密码'));
			} else if (value!=this.ruleForm2.password) {
				return callback(new Error('两次密码不一致'));
			} else {
				callback();
			}
		};
		return {
			tags:[],
			ruleForm2:{
				old_password:'',
				password:'',
				re_password:'',
			},
			rules2:{
				old_password: [{
					required: true,
					message: '请输入旧密码',
					trigger: 'blur'
				}],
				password: [
					{
						required: true,
						validator: validatorCaptcha,
						trigger: 'blur'
					}
				],
				re_password: [{
					required: true,
					validator: validator_re_password,
					trigger: 'blur'
				}],
			},
			user_name:'',
			modify_password_is:false,
			collapsed: false,
			path: '',
			routes: [
				{
					path: 'system_staff',
					icon_url: 'iconxitong',
					name: '系统设置',
					children: [
						{
							path: 'system_staff',
							icon_url: 'iconyuangong',
							name: '员工管理'
						},
						{
							path: 'system_help',
							icon_url: 'iconbangzhu',
							name: '使用帮助'
						},
						{
							path: 'system_about',
							icon_url: 'iconguanyuwomen',
							name: '关于我们'
						},
						{
							path: 'system_advertising',
							icon_url: 'iconguanggao',
							name: '广告管理'
						},
					]
				},
				{
					path: 'data_area',
					name: '数据字典',
					icon_url: 'iconshujuzidian',
					children: [
						{
							path: 'data_area',
							icon_url: 'iconpianqu',
							name: '片区管理'
						},
						{
							path: 'data_massif',
							icon_url: 'icondikuai',
							name: '地块管理'
						},
						{
							path: 'data_parameter',
							icon_url: 'iconcanshu',
							name: '参数管理'
						}
					],
				},
				{
					path: 'list_index',
					name: '数据管理',
					icon_url: 'iconshujuguanli',
					children: [
						{
							path: 'list_index',
							icon_url: 'iconbiaodan',
							name: '种质资源（品种）'
						},
						{
							path: 'list_index_youxi',
							icon_url: 'iconbiaodan',
							name: '种质资源（优系）'
						},
						{
							path: 'list_index_qita',
							icon_url: 'iconbiaodan',
							name: '种质资源（其他）'
						},
						{
							path: 'list_fixed',
							icon_url: 'iconzichan',
							name: '固定资产管理'
						},
						{
							path: 'list_news',
							icon_url: 'iconxinwen',
							name: '资讯管理'
						},
					],
				}
			],
		}
	},
	mounted() {
		this.path = this.$route.path.replace('/', '');
		this.user_name = sessionStorage.getItem('user_name') || '';
		this.user_type = sessionStorage.getItem('user_type') || '';
		this.tags_list();
	},
	methods: {
		hreftwo(data) {
			var this_ = this;
			var date = new Date().getTime();
			// console.log(data);
			var tags = this_.tags;
			var y = 0;
			tags.forEach(function (e, i) {
				if (e.path == data.path) {
					y++;
				}
			});
			if (y == 0) {

				this_.tags.push(data);
			}
			this_.path = data.path;
			this_.$router.push({
				path: data.path,
				query: {
					t: date
				}
			})
		},
		xianshi(path){
			if (this.user_type==2) {
				return true
			}else{
				if (path=='system_staff') {
					return false
				}else{
					return true
				}
			}
		},
		tags_list() {
			var this_ = this;
			var menu = this_.routes;
			menu.forEach(function (e, i) {
				var chid = e.children;
				for (var i = 0; i < chid.length; i++) {
					var n = chid[i]
					if (n.path == this_.path) {
						this_.tags.push(n)
						break;
					}
				}
			});
		},
		//退出登录
		logout: function () {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				sessionStorage.removeItem('user');
				_this.$router.push('/login');
			}).catch(() => {

			});
		},
		tag_del(data, index) {
			var this_ = this;
			var date=new Date().getTime();
			var tags = this_.tags;
			if (tags.length > 1) {
				for (var i = 0; i < tags.length; i++) {
					if (index == i) {
						tags.splice(i, 1);
						break;
					}
				}
			}
			if (this_.path == data.path) {
				var datas = tags[tags.length - 1];
				this_.path = datas.path;
				this_.$router.push({
					path: datas.path,
					query: {t: date }
				})
			}
		},
		yungongaddNew(){
			var this_ = this;
			var url = "changePassword";
			this_.$refs.ruleForm2.validate((valid) => {
				if (valid) {
					var datas = {
						old_password: this_.ruleForm2.old_password,
						password: this_.ruleForm2.password,
						re_password: this_.ruleForm2.re_password,
					}
					this_.$post(url, datas).then((res) => {
						// console.log(res);
						this_.$message.success('修改成功请使用新密码');
						this_.modify_password_is = false;
					});
				}
			})
		},
	},
}
</script>
<style>
.content-panel {
	min-height: calc(100vh - 80px);
	/* background: #ffffff; */
	padding: 20px 30px;
}
.tree-content{
	width: 100%;
}
</style>
<style scoped>
.container {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}
.container .header {
	height: 60px;
	line-height: 60px;
	background: #367f4a;
	color: #fff;
}
.container .header .userinfo {
	text-align: right;
	padding-right: 35px;
	float: right;
}
.container .header .userinfo .userinfo-inner {
	cursor: pointer;
	color: #fff;
}
.container .header .logo {
	height: 60px;
}
.container .header .logo img {
	height: 100%;
}
.container .header .logo-width {
	width: 230px;
}
.container .header .logo-collapse-width {
	width: 60px;
	padding: 0;
}
.container .header .tools {
	padding: 0px 23px;
	width: 14px;
	font-size: 24px;
	height: 60px;
	line-height: 60px;
	cursor: pointer;
}
.container .main {
	display: flex;
	position: absolute;
	top: 60px;
	bottom: 0px;
	overflow: hidden;
}
.container .main aside {
	width: 230px;
	background-color: #fff;
}
.container .main aside.menu-collapsed {
	width: 60px;
}
.container .main .el-menu {
	height: 100%;
	border-right: none;
}
.container .content-container {
	flex: 1;
	padding: 10px;
	overflow-y: auto;
}
.container .content-container .biaoqian {
	margin-bottom: 10px;
}
.container .content-container .my-scroll-bar {
	height: 45px;
	white-space: nowrap;
}
.container .content-container .biaoqian .el-tag {
	cursor: pointer;
}
.container .content-container .biaoqian .el-tag+.el-tag {
	margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue